<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim :options="notfound" class="anim" :height="getScreen ? 200 : 500" :width="getScreen ? 200 : 500"></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block @click="$router.go(-1)">
          <a-icon type="rollback" />&nbsp; Return
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="pageLoading" class="margin-bottom">
            <div slot="title">
              <h4 class="margin-remove">{{ "PI Manifest".toUpperCase() }}</h4>
              <small>{{ data.header.no_pi ? data.header.no_pi : "" }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button type="primary" size="small" icon="printer" block ghost @click="handlePrint"
                    class="m-display-block">Manifest</a-button>
                </li>
                <li v-if="getAuth.username == data.user_pembuat.tlc">
                  <!-- <a-button-group> -->
                  <a-button :disabled="!(
                    data.last_status == 'Revised' &&
                    getAuth.username == data.user_pembuat.tlc
                  )
                    " @click="handleEdit" type="dashed" size="small" icon="edit" block
                    class="m-display-block">Edit</a-button>
                  <!-- </a-button-group> -->
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{
                    moment(data.header.tanggal_buat).format(
                      getDefaultDateFormat
                    )
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{
                    data.header.user_pembuat
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Cost Center</span>
                  <span class="m-list-desc">{{ data.header.cost_center }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Financial Item / Code</span>
                  <span class="m-list-desc">{{ data.header.item_anggaran }} /
                    {{ data.header.kode_anggaran }}</span>
                </li>
                <!-- <li>
                  <span class="m-list-title" for>Description</span>
                  <span
                    class="m-list-desc"
                  >{{data.header.description}}</span>
                </li> -->
                <li>
                  <span class="m-list-title" for>Be required</span>
                  <span class="m-list-desc">{{
                    moment(data.header.be_required).format(getDefaultDateFormat)
                  }}</span>
                </li>
                <!-- <li>
                  <span class="m-list-title" for>Lead time</span>
                  <span
                    class="m-list-desc"
                  >{{data.header.leadtime}}</span>
                </li> -->
                <li>
                  <span class="m-list-title" for>End User</span>
                  <span class="m-list-desc">{{ data.header.enduser }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Currency</span>
                  <span class="m-list-desc">{{ data.currency }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Value</span>
                  <span class="m-list-desc">{{
                    formatCurrency(
                      data.currency,
                      data.financedtl.estimation_price
                    )
                  }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Usage Details</h4>
                <div>
                  <!-- <a-button
                      @click="toKodeSetoran"
                      :type="typetaxbutton"
                      class="margin-right-small"
                      size="small"
                      v-if="isTaxOfficer"
                    >
                      <a-icon type="select" />
                      Tax Deposit
                    </a-button> -->
                </div>
              </div>
              <a-input-search v-model="search" placeholder="Quick Search" allowClear :change="searching"
                class="margin-bottom" />
              <a-table :columns="columns" :dataSource="tableData" :pagination="pagination" size="small" bordered
                :scroll="{ x: 100 }">
                <span slot="jmlbarang" slot-scope="jmlbarang">
                  <div style="text-align: center; width: 100%">
                    {{ jmlbarang.jumlah_barang }} {{ jmlbarang.satuan }}
                  </div>
                </span>
                <span slot="harga" slot-scope="harga">
                  <CurrencyJustified v-if="harga" :currencyValue="data.currency" :valueNumber="harga" />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <span slot="total" slot-scope="sisa">
                  <CurrencyJustified :currencyValue="data.currency" :valueNumber="sisa" />
                </span>

                <span slot="doc_tax" slot-scope="item">
                  <div style="text-align: center;">
                    <a-button icon="edit" size="small"
                      :type="item.kode_setoran_pajak != null && item.kode_setoran_pajak != null ? 'primary' : 'danger'"
                      style="margin-right:5px" @click="handleShowTaxModal(item)"
                      :disabled="!(data.jenis == 'Verifikator' && item.type_pi == 'Tax' && item.type_tax != 'bea_masuk')">
                    </a-button>

                    <a-button icon="file" disabled size="small"
                      v-if="item.type_pi == 'Tax' && item.document_tax == 'No File Uploaded'">
                    </a-button>
                    <a-button icon="file" @click="handleViewDocLink(item)" size="small"
                      v-if="item.type_pi == 'Tax' && item.document_tax != 'No File Uploaded'">
                    </a-button>
                  </div>
                </span>

                <div slot="footer">
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left">
                      <h3>Grand Total</h3>
                    </a-col>
                    <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
                      <h3>
                        {{
                          formatCurrency(
                            data.currency,
                            Number(data.financedtl.estimation_price)
                          )
                        }}
                      </h3>
                    </a-col>
                  </a-row>
                </div>
              </a-table>

              <!-- <div class="m-card-body">
                <ul class="m-list-wrapper bordered">
                  <li>
                    <span class="m-list-title" for>Grand Total</span>
                    <span class="m-list-desc">{{formatCurrency(data.currency,data.financedtl.estimation_price)}}</span>
                  </li>
                </ul>
              </div> -->
            </a-collapse-panel>
          </a-collapse>

          <template v-if="!getScreen">
            <a-card class="margin-top" :loading="pageLoading" v-if="data.jenis.toLowerCase() !== 'manifest' &&
              data.jenis.toLowerCase() !== 'transfer'
              ">
              <div slot="title">Manifest Actions</div>

              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea placeholder="Write the note here ... " :rows="4" v-decorator="['catatan']" />
                </a-form-item>
                <a-form-item label="Aksi" v-if="data.aksi">
                  <a-select showSearch v-decorator="['aksi', { rules: [{ required: true }] }]">
                    <a-select-option v-for="item in data.aksi" :key="item.aksi">{{ item.aksi }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button @click="handleActionConfirm" block type="primary" html-type="submit">Save</a-button>
              </template>
            </a-card>
            <a-card class="margin-top" :loading="pageLoading" v-if="data.jenis.toLowerCase() === 'transfer'">
              <div slot="title">
                Manifest Actions &nbsp;<i v-if="data.jenis == 'Transfer' && !data.status_transfer"
                  style="color: red !important">(Funding has not been set)</i>
              </div>
              <div slot="extra">
                <h5 class="m-text-align right margin-remove">
                  Remaining Balance
                </h5>
                <a-tag color="green">
                  {{ formatCurrency(data.currency, data.sisa_tf) }}
                </a-tag>
              </div>
              <template v-if="!(data.jenis == 'Transfer' && !data.status_transfer)">
                <a-form :form="form">
                  <a-form-item label="Aksi" v-if="data.aksi">
                    <a-select @change="changeAction" showSearch v-decorator="[
                      'status',
                      {
                        rules: [{ required: true }],
                        initialValue: 'Transferred',
                      },
                    ]">
                      <a-select-option v-for="item in data.aksi" :key="item.aksi">{{ item.aksi }}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Transfer Date" v-if="aksiSelected === 'Transferred' || aksiSelected === ''">
                    <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat"
                      v-decorator="['tgl_trf', { rules: [{ required: true }] }]" />
                  </a-form-item>
                  <a-form-item label="Evidence of Transfer" v-if="aksiSelected === 'Transferred' || aksiSelected === ''">
                    <a-upload accept="image/*" :showUploadList="true" :fileList="push" listType="picture"
                      :beforeUpload="beforeUpload" :remove="handleRemoveList" v-decorator="[
                        'upload',
                        { rules: [{ required: true }] },
                        { valuePropName: 'push' },
                      ]">
                      <a-button>
                        <a-icon type="upload" />&nbsp;Select File
                      </a-button>
                    </a-upload>
                  </a-form-item>
                  <a-form-item label="Transfer Value" v-if="aksiSelected === 'Transferred' || aksiSelected === ''">
                    <a-input-number :disabled="disabled" type="number" :max="data.sisa_tf"
                      class="m-width-full m-text-align right" v-decorator="[
                        'value_transferan',
                        {
                          rules: [{ required: true }],
                          initialValue: data.sisa_tf,
                        },
                      ]" />
                  </a-form-item>
                  <a-checkbox v-if="aksiSelected === 'Transferred' || aksiSelected === ''" class="margin-bottom"
                    @change="handleCheckData" :checked="checkTransferValue">The transferred value matches the remaining
                    balance</a-checkbox>
                  <a-form-item label="Note">
                    <a-textarea placeholder="Write the note here ... " :rows="4" v-decorator="['remark']" />
                  </a-form-item>
                </a-form>
                <template class="ant-card-actions" slot="actions">
                  <a-button @click="handleActionConfirm" block type="primary" html-type="submit">Save</a-button>
                </template>
              </template>
            </a-card>
          </template>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-card :loading="pageLoading" :class="getScreen ? 'margin-top' : ''">
            <div slot="title">Evidence of Transfer</div>
            <div>
              <a-alert v-if="data.bukti_transfer.length <= 0" type="error" message="No evidence of transfer was uploaded"
                banner />
              <a-list itemLayout="horizontal" :dataSource="data.bukti_transfer" v-else>
                <Empty v-if="data.bukti_transfer
                  ? data.bukti_transfer.length <= 0
                  : data.bukti_transfer
                  " />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between">
                      <h3 class="margin-remove">
                        {{ moment(item.tgl_tf).format(getDefaultDateFormat) }}
                      </h3>

                      <a-button @click="handleViewDt(item)" size="small" type="default" icon="eye">View</a-button>
                      <h4 class="margin-remove">
                        {{ formatCurrency(data.currency, item.value_tf) }}
                      </h4>
                    </div>
                    <img v-if="item.url.indexOf('.pdf') >= 0" class="m-image-icon" slot="avatar"
                      src="@/assets/icon/pdf_ico.png" />
                    <img v-else class="m-image-icon" slot="avatar" :src="$serviceUrl + item.url" />
                    <p slot="description" class="margin-remove">
                      {{ item.user_tf }}
                    </p>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </div>
          </a-card>
          <a-collapse :class="'margin-top'" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status v-if="data.last_status" :status="data.last_status" />
                  <a-button @click="historyToggle" type="default" size="small" class="margin-right-small">
                    History
                    <a-icon type="history" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-spin :spinning="pageLoading">
                  <a-timeline-item color="green">
                    <div class="m-timeline-title">
                      Pembuat - {{ data.user_pembuat.tlc }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove">
                        {{
                          moment(data.header.tanggal_buat).format(
                            getDefaultDateFormat
                          )
                        }}
                      </h4>
                      <span class="m-text-small" v-if="data.user_pembuat.catatan">{{ data.user_pembuat.catatan }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <a-tag color="green">{{
                        data.user_pembuat.status
                      }}</a-tag>
                    </div>
                  </a-timeline-item>
                  <a-timeline-item v-for="workflow in data.status" :key="workflow.step_no" :color="workflow.status === 'On Process' ||
                    workflow.status === 'Delivered'
                    ? 'red'
                    : workflow.status === 'Waiting'
                      ? 'grey'
                      : 'green'
                    ">
                    <div class="m-timeline-title">
                      {{ workflow.actor ? workflow.actor : workflow.job_desc }}
                      {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                        {{
                          moment(workflow.tanggal_aksi).format(
                            getDateTimeFormat
                          )
                        }}
                      </h4>
                      <span class="m-text-small" v-if="workflow.remark">{{
                        workflow.remark
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <Status :status="workflow.status" />
                    </div>
                  </a-timeline-item>
                </a-spin>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list itemLayout="horizontal" :dataSource="data.dokumen_terkait">
                <Empty v-if="data.dokumen_terkait
                  ? data.dokumen_terkait.length <= 0
                  : data.dokumen_terkait
                  " />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between align-middle">
                      <a @click="handleView(item)">{{ item.header }} | {{ item.tlc }}</a>
                      <Status :class="!getScreen ? 'margin-remove' : ''" :status="item.status" />
                    </div>
                    <div slot="title" class="m-display-flex space-between align-middle" v-if="item.no_manifest">
                      <span>{{ item.no_manifest }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span>{{
                        moment(
                          item.tgl_mulai_dinas,
                          getStandartFormatDate
                        ).format(getDefaultDateFormat)
                      }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}</span>
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip class="ant-tooltip-inner" placement="top" :title="item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                            ">
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                            ? item.deskripsi
                            : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div slot="title" v-if="item.value_transaksi">
                      <span class="m-timeline-title">{{
                        formatCurrency(data.mata_uang, item.value_transaksi)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
          <template v-if="getScreen">
            <a-card class="margin-top" :loading="pageLoading" v-if="data.jenis.toLowerCase() !== 'manifest' &&
              data.jenis.toLowerCase() !== 'transfer'
              ">
              <div slot="title">Manifest Actions</div>

              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea placeholder="Write the note here ... " :rows="4" v-decorator="['catatan']" />
                </a-form-item>
                <a-form-item label="Aksi">
                  <a-select showSearch v-decorator="['aksi', { rules: [{ required: true }] }]">
                    <a-select-option v-for="item in data.aksi" :key="item.aksi">{{ item.aksi }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button @click="handleActionConfirm" block type="primary" html-type="submit">Save</a-button>
              </template>
            </a-card>
            <a-card class="margin-top" :loading="pageLoading" v-if="data.jenis.toLowerCase() === 'transfer'">
              <div slot="title">
                Manifest Actions &nbsp;<i v-if="data.jenis == 'Transfer' && !data.status_transfer"
                  style="color: red !important">(Funding has not been set)</i>
              </div>
              <div slot="extra">
                <h5 class="m-text-align right margin-remove">
                  Remaining Balance
                </h5>
                <a-tag color="green">
                  {{ formatCurrency(data.currency, data.sisa_tf) }}
                </a-tag>
              </div>
              <template v-if="!(data.jenis == 'Transfer' && !data.status_transfer)">
                <a-form :form="form">
                  <a-form-item label="Aksi">
                    <a-select showSearch @change="changeAction" v-decorator="['status', { rules: [{ required: true }] }]">
                      <a-select-option v-for="item in data.aksi" :key="item.aksi">{{ item.aksi }}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Transfer Date" v-if="aksiSelected === 'Transferred' || aksiSelected === ''">
                    <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat"
                      v-decorator="['tgl_trf', { rules: [{ required: true }] }]" />
                  </a-form-item>
                  <a-form-item label="Evidence of Transfer" v-if="aksiSelected === 'Transferred' || aksiSelected === ''">
                    <a-upload accept="image/*" :showUploadList="true" :fileList="push" :remove="handleRemoveList"
                      listType="picture" :beforeUpload="beforeUpload" v-decorator="[
                        'upload',
                        { rules: [{ required: true }] },
                        { valuePropName: 'push' },
                      ]">
                      <a-button>
                        <a-icon type="upload" />&nbsp;Select File
                      </a-button>
                    </a-upload>
                  </a-form-item>
                  <a-form-item label="Transfer Value" v-if="aksiSelected === 'Transferred' || aksiSelected === ''">
                    <a-input-number :disabled="disabled" type="number" :max="data.sisa_tf"
                      class="m-width-full m-text-align right" v-decorator="[
                        'value_transferan',
                        { rules: [{ required: true }] },
                      ]" />
                  </a-form-item>
                  <a-checkbox v-if="aksiSelected === 'Transferred' || aksiSelected === ''" class="margin-bottom"
                    @change="handleCheckData" :checked="checkTransferValue">The transferred value matches the remaining
                    balance</a-checkbox>
                  <a-form-item label="Note">
                    <a-textarea placeholder="Write the note here ... " :rows="4" v-decorator="['remark']" />
                  </a-form-item>
                </a-form>
                <template class="ant-card-actions" slot="actions">
                  <a-button @click="handleActionConfirm" block type="primary" html-type="submit">Save</a-button>
                </template>
              </template>
            </a-card>
          </template>
        </a-col>
      </a-row>
    </div>
    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="history" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title" v-if="history.aksi === '4' && history.deskripsi === 'Edited'">
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }}
                {{ history.tlc_to ? "|" + history.tlc_to : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <div class="margin-top"></div>
      <a-divider class="margin-small" />
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>

    <TaxDepositEntry :v-if="visibleTaxModal" :visibleTaxModal="visibleTaxModal" :getType_tax="getType_tax"
      :getListsetoranpajak="datapajak.getListsetoranpajak" :getListobjekpajak="datapajak.getListobjekpajak"
      :tax_type="data.detail_invoice ? data.detail_invoice[0].type_tax : null"
      :file_document_tax="data.detail_invoice ? data.detail_invoice[0].file_document_tax : null"
      :kode_setoran_pajak="data.detail_invoice ? data.detail_invoice[0].kode_setoran_pajak : null"
      :objek_pajak="data.detail_invoice ? data.detail_invoice[0].kode_objek_pajak : null" :id_header="this.id"
      :id_dtl="this.id" :dpp_value="data.detail_invoice ? data.detail_invoice[0].dpp_value : null"
      :value="data.detail_invoice ? data.detail_invoice[0].tax_value : null" :file="datapajak.fileList"
      jenis_transaksi="pi" :hideUploadDocTax="true" />
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import lottie from "vue-lottie";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import TaxDepositEntry from "@/components/TaxDepositEntry.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";
import _ from "lodash";

export default {
  name: "ManifestPi",
  components: { "m-anim": lottie, Status, TaxDepositEntry },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    return {
      status_transfer: true,
      previewVisible: false,
      previewImage: "",
      visibleHistory: false,
      pageLoading: false,
      disabled: true,
      data: {
        header: {
          no_pi: "",
        },
        financedtl: {
          estimation_price: 0,
        },
        user_pembuat: {
          tlc: "",
        },
        jenis: "",
        last_status: null,
        sisa_tf: null,
        aksi: null,
        bukti_transfer: [],
        // detail_invoice: [],
        // dokumen_terkait: {
        //   tlc:""
        // },
        status: [],
        history: [],
        currency: "IDR",
        workflow: {
          tlc: "",
        },
      },
      push: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      tableData: [],
      tableDataTemp: [],
      search: "",
      aksiSelected: "",
      checkTransferValue: true,
      visibleTaxModal: false,
      datapajak: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStandartFormatDate",
      "getType_tax",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          dataIndex: "key",
          key: "key",
          width: 60,
          sorter: (a, b) => a.no.length - b.no.length,
          footer: () => {
            return "<div>Summary</div>";
          },
        },
        {
          title: "Item Name",
          dataIndex: "nama_barang",
          key: "nama_barang",
          width: 200,
          sorter: (a, b) => a.deskripsi.length - b.deskripsi.length,
        },

        {
          title: "Quantity",
          key: "jumlah_barang",
          width: 100,
          sorter: (a, b) => a.debit.length - b.debit.length,
          scopedSlots: { customRender: "jmlbarang" },
        },
        {
          title: "Unit Price",
          dataIndex: "harga",
          key: "harga",
          width: 120,
          sorter: (a, b) => a.kredit.length - b.kredit.length,
          scopedSlots: { customRender: "harga" },
        },
        {
          title: "Amount",
          dataIndex: "total",
          key: "total",
          width: 120,
          sorter: (a, b) => a.sisa.length - b.sisa.length,
          scopedSlots: { customRender: "total" },
        },
      ];

      if (this.isTaxOfficer) {
        kolom.push({
          title: "Tax Deposit",
          key: "doc_tax",
          fixed: "right",
          scopedSlots: { customRender: "doc_tax" },
          width: 100,
        },);
      }

      return kolom;
    },
    searching() {
      let self = this;
      if (this.search) {
        self.tableData = this.tableData.filter(
          (obj) =>
            obj.nama_barang.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0
        );
      }

      if (!this.search) {
        self.tableData = this.tableDataTemp;
      }

      return this.tableData;
    },
    isTaxOfficer() {
      let data = _.filter(this.getAuth.nama_bidang, (obj) => obj == "Tax Officer");
      return data.length > 0 ? true : false;
    },
    isValidTaxOfficerValue() {
      let data = _.filter(this.data.detail_invoice, (obj) => obj.type_pi == "Tax" && obj.kode_setoran_pajak == null && obj.type_tax != 'bea_masuk');
      return data.length > 0 ? false : true;
    },
    typetaxbutton() {
      let result = 'default';
      if (this.data.detail_invoice) {
        if (this.data.detail_invoice[0].type_pi == 'Tax' && this.data.detail_invoice[0].kode_setoran_pajak == null) {
          result = 'danger';
        } else if (this.data.detail_invoice[0].type_pi == 'Tax' && this.data.detail_invoice[0].kode_setoran_pajak != null) {
          result = 'primary';
        }
      }
      return result;
    }
  },
  methods: {
    moment,
    fetchManifest() {
      this.pageLoading = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "pi",
        params: {
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.id = response.data.invoice[0].id_payment_instruction;
          this.data = {
            header: {
              no_pi: response.data.invoice[0].no_payment_instruction,
              tanggal_buat: response.data.invoice[0].create_dt,
              total_um: response.data.invoice[0].total_um_1 || 0,
              total_pemakaian: response.data.invoice[0].total_pemakaian_1 || 0,
              total_sisa_saldo:
                response.data.invoice[0].total_sisa_saldo_1 || 0,
              user_pembuat: response.data.invoice[0].nama,
              cost_center: response.data.invoice[0].cost_center_kode,
              item_anggaran: response.data.invoice[0].item_anggaran,
              kode_anggaran: response.data.invoice[0].kode_anggaran,
              description: "kosong dul",
              be_required: response.data.invoice[0].be_required,
              leadtime: "kosong dul",
              enduser: response.data.invoice[0].end_user,
            },
            financedtl: {
              estimation_price: response.data.invoice[0].value_asli,
              exchange_rate: 1,
              convertion_value: 1,
              downpayment: 1,
              total_usage: 1,
              balance: 1,
            },
            currency: response.data.invoice[0].currency,
            jenis: response.data.jenis,
            last_status: response.data.invoice[0].status,
            user_pembuat: {
              tlc: response.data.invoice[0].tlc,
              tanggal: response.data.invoice[0].tgl_buat,
              status: "Created",
            },
            sisa_tf: response.data.sisa_tf,
            aksi: response.data.aksi,
            bukti_transfer: response.data.detail_bukti_transfer,
            detail_invoice: response.data.dtl_invoice,
            dokumen_terkait: response.data.dokumen_terkait,
            status: response.data.status_app,
            history: response.data.notifikasi,
            status_transfer: response.data.status_transfer,
            setoran_pajak: response.data.setoran_pajak,
            objek_pajak: response.data.objek_pajak,
          };

          this.currency = response.data.invoice[0].currency;

          //usage detil
          this.tableData = response.data.dtl_invoice;
          this.tableDataTemp = response.data.dtl_invoice;
          //end

          if (this.isTaxOfficer) {
            this.datapajak.getListsetoranpajak = response.data.setoran_pajak;
            this.datapajak.getListobjekpajak = response.data.objek_pajak;
            this.datapajak.tax_type = null;
            this.datapajak.file_document_tax = null;
            this.datapajak.kode_setoran_pajak = null;
            this.datapajak.objek_pajak = null;
            this.datapajak.id_header = null;
            this.datapajak.id_dtl = null;
            this.datapajak.dpp_value = null;
            this.datapajak.value = null;
            this.datapajak.fileList = null;
          }

          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.data = {};
          this.pageLoading = false;
          this.$router.go(-1);
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handlePrint(item) {
      this.pageLoading = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "pi/cetak_laporan_um_pi",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_pi: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
          //this.$router.go(-1);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "EditPi",
        params: { id: this.id },
      });
    },
    handleActionConfirm() {
      let sts = this.form.getFieldValue("aksi");
      if (sts == 'Verified' && this.isValidTaxOfficerValue) {
        this.confirmMessage("confirm-save");
      } else if (sts !== 'Verified') {
        this.confirmMessage("confirm-save");
      } else {
        this.displayMessageValue("error-other", "There is still Document Tax data that hasn't been filled in!");
      }
    },
    handleAction() {
      if (this.data.jenis.toLowerCase() === "transfer") {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }

          if (this.push.length == 0) {
            this.displayMessage("empty-evidence");
            return;
          }
          if (values.value_transferan == 0) {
            this.displayMessage("grather0");
            return;
          } else {
            let post = new FormData();
            if (this.aksiSelected === "Revised") {
              post.append("status", values.status);
              post.append("remark", values.remark ? values.remark : "");
              post.append("tlc", this.getAuth.username);
              post.append("id_manifest", this.id);
            } else {
              post.append("id_manifest", this.id);
              post.append("tlc", this.getAuth.username);
              post.append("status", values.status);
              post.append("remark", values.remark ? values.remark : "");
              post.append(
                "tgl_transfer",
                values.tgl_trf.format(this.getStandartFormatDate)
              );
              post.append("cek_value", this.checkTransferValue ? 1 : 0);
              post.append("value_transfer", values.value_transferan);
              post.append("file_transfer", this.push[0]);
            }

            axios({
              method: "post",
              url: this.$serviceUrl + "pi/approval",
              processData: false,
              data: post,
              auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": this.getAuth.apikey,
              },
            })
              .then((response) => {
                this.displayMessage("success");
                this.$router.go();
              })
              .catch((err) => {
                let response = Object.assign({}, err.response);
                if (response.data.status == false && response.data.message) {
                  this.displayMessageValue("error-other", response.data.message);
                } else {
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error", responses);
                }
              });
          }
        });
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("choose-action");
            return;
          }

          axios({
            method: "post",
            url: this.$serviceUrl + "pi/approval ",
            processData: false,
            data: {
              id_manifest: this.id,
              tlc: this.getAuth.username,
              status: values.aksi,
              remark: values.catatan,
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.$router.go();
            })
            .catch((err) => {
              let response = Object.assign({}, err.response);
              if (response.data.status == false && response.data.message) {
                this.displayMessageValue("error-other", response.data.message);
              } else {
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error", responses);
              }
            });
        });
      }
    },
    handleCheckData(e) {
      if (e.target.checked) {
        this.disabled = true;
        this.checkTransferValue = true;
        this.form.setFieldsValue({
          value_transferan: this.data.sisa_tf,
        });
      } else {
        this.disabled = false;
        this.checkTransferValue = false;
        this.form.setFieldsValue({
          value_transferan: 0,
        });
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    handleRemoveList(file) {
      const index = this.push.indexOf(file);
      const newFileList = this.push.slice();
      newFileList.splice(index, 1);
      this.push = newFileList;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleViewDt(file) {
      if (file.url.substr(file.url.length - 3) === "pdf") {
        window.open(this.$serviceUrl + file.url, "_blank");
      } else {
        this.previewImage = this.$serviceUrl + file.url;
        this.previewVisible = true;
      }
    },
    changeAction(item) {
      this.aksiSelected = item;
    },
    toKodeSetoran(e) {
      e.stopPropagation();
      this.visibleTaxModal = !this.visibleTaxModal;
    },
    taxDepositEntryCancel() {
      this.visibleTaxModal = false;
    },
    taxDepositEntryUpdate(val) {
      //let index = _.findIndex(this.data.detail_invoice, { adendum_id_dtl: val.id_dtl });
      let index = 0;
      this.data.detail_invoice[index]['file_doc_tax'] = null;
      this.data.detail_invoice[index].file_doc_tax = val.document_tax;
      this.data.detail_invoice[index]['document_tax'] = null;
      this.data.detail_invoice[index].document_tax = val.document_tax;
      this.data.detail_invoice[index]['document_path'] = null;
      this.data.detail_invoice[index].document_path = val.document_path;
      this.data.detail_invoice[index].tax_value = val.tax_value;
      this.data.detail_invoice[index].kode_objek_pajak = val.objek_pajak;
      this.data.detail_invoice[index].kode_setoran_pajak = val.kode_setoran_pajak;
      this.data.detail_invoice[index].dpp_value = val.dpp_value;
      this.data.detail_invoice[index]['document_file'] = null;
      this.data.detail_invoice[index].document_file = val.file_document_tax;
    },
    async handleShowTaxModal(item) {
      this.datapajak.tax_type = item.type_tax;
      this.datapajak.kode_setoran_pajak = item.kode_setoran_pajak;
      this.datapajak.objek_pajak = item.kode_objek_pajak;
      this.datapajak.id_header = this.id;
      this.datapajak.id_dtl = this.id;
      this.datapajak.dpp_value = item.dpp_value;
      this.datapajak.value = item.tax_value;
      this.datapajak.getListsetoranpajak = _.filter(this.data.setoran_pajak, (obj) => obj.id_type_tax == item.type_tax);
      this.datapajak.getListobjekpajak = _.filter(this.data.objek_pajak, (obj) => obj.id_type_tax == item.type_tax);

      if (item.file_doc_tax != null && item.file_doc_tax != "No File Uploaded") {
        let typefile = this.fileTypeFromUrl(item.file_doc_tax);
        let file = this.dataURLtoFile(typefile + item.document_file, item.file_doc_tax);
        file.uid = 'vc-upload-1-1';
        file.status = 'done';
        file.url = this.$serviceUrl + item.document_path;
        this.datapajak['fileList'] = [];
        this.datapajak.fileList.push(file);
      }
      this.visibleTaxModal = true;
    },
    handleViewDocLink(item) {
      window.open(this.$serviceUrl + item.document_path);
    },
  },
  created() { },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.push = [];
        this.checkTransferValue = true;
        this.disableNilaiTf = false;
        this.search = "";
      }
    },
  },
  mounted() {
    this.$store.dispatch("Fetch_TYPE_TAX");
    Event.$on("confirmMessageReturn", this.handleAction);
    Event.$on("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$on("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
    this.fetchManifest();
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleAction);
    Event.$off("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$off("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
  },
};
</script>

<style scoped lang="less">
.m-image-icon {
  width: 50px;
}
</style>